
import React from 'react';
import CertCard from '../../components/Cards/CertCard';
import { certifications } from './helper';
const Certifications = (): JSX.Element =>
(
    <div className='Certifications'>
        {
            certifications.map((cert) =>

                <CertCard
                    key={cert.alt}
                    title={cert.title}
                    date={cert.date}
                    alt={cert.alt}
                    img={cert.img}
                    certificate={cert.certificate}
                    cradential={cert.cradential} />
            )
        }
    </div>
)

export default Certifications;
